var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5943c5d7320b509a48e357e6f10a8bdd02f66734"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["3hcctv@webandroll"]={id:"5943c5d7320b509a48e357e6f10a8bdd02f66734"};
      